'use client'

import Link from 'next/link'
import { cn, buttonVariants, buttonIconVariants } from 'design-system'
import { ArrowLeft } from 'lucide-react'

export const BackToLoginButton = () => (
  <Link
    href="/"
    className={cn(
      buttonVariants({ buttonType: 'transparent' }),
      'text-yd-blue hover:text-blue-800'
    )}>
    <ArrowLeft className={buttonIconVariants({ buttonSize: 'xs' })} />
    Back to Login
  </Link>
)
